import { parseHTMLToOoxmlCursively } from './HTML';
import { convertToOOXML, blankParagraph } from "./OOXML";
export { parseTDToOOXML } from "./HTML.TD";

export function parseTableToOOXML(ctx, parentOOXML, ooxmlChildren, node) {
    const tableProps = [
        // {tag: "w:tblStyle", attrs: { "w:val": "667" }, children: []},
        {tag: "w:tblW", attrs: {"w:w": "0", "w:type": "auto"}, children: []},
                                
    ];
    if (node.hasAttribute("cellspacing")) {
        let spacing = Math.round(parseInt(node.getAttribute("cellspacing")) * 1.5);
        if (!isNaN(spacing)) {
            spacing = 0
        }
        
        tableProps.push({ tag: "w:tblCellSpacing", attrs: { "w:w": `${spacing}`, "w:type": spacing? "dxa" : "nil" } });
    }
    tableProps.push({tag: "w:tblLook", attrs: {
        "w:val": "04A0",
        "w:firstRow": "1",
        "w:lastRow": "0",
        "w:firstColumn": "1",
        "w:lastColumn": "0",
        "w:noHBand": "0",
        "w:noVBand": "1"
      }, children: []});
    const tblGridChildren = [];
    ctx.vMerges = {};
    const columnCount = Array.from(node.getElementsByTagName("tr")).reduce((prev, node) => Math.max(prev, node.getElementsByTagName("td").length), 0);
    for (let c = 0; c < columnCount; c ++) {
        tblGridChildren.push({tag: "w:gridCol", attrs: {"w:w": "2000"}});
    }
    Array.from(node.childNodes).forEach(cn => {
        parseHTMLToOoxmlCursively(ctx, cn, parentOOXML).forEach(pr => ooxmlChildren.push(pr));
    });
    delete ctx.vMerges;
    return  [convertToOOXML({
        tag: "w:tbl",
        ooxmlChildren,
        children: [
            {tag: "w:tblPr", children: tableProps },
            {tag: "w:tblGrid", children: tblGridChildren}
        ]
    }, parentOOXML)];
}
                
export function parseTRToOOXML(ctx, parentOOXML, ooxmlChildren, node) {
    if (!ctx.vMerges) ctx.vMerges = {};
    let colId = 0;
    const processRowIds = () => {
        while (ctx.vMerges[colId] && ctx.vMerges[colId] > 1) {
            ctx.vMerges[colId] -= 1;
            const props = [...(ctx?.lastCellProps || [])].filter(prop => prop.tag !== "w:gridSpan");
            let mergeAfterIndex = props.findIndex(a => a.tag === "w:vMerge");
            if (mergeAfterIndex >= 0) props.splice(mergeAfterIndex, 1);
            else  {
                ["w:gridSpan", "w:tcW"].some(a => {
                    mergeAfterIndex = props.findIndex(p => p.tag === a);
                    return mergeAfterIndex >= 0;
                });
                mergeAfterIndex += 1;
            }
            props.splice(mergeAfterIndex, 0, {tag: "w:vMerge", attrs: {"w:val": "continue"}});
            ooxmlChildren.push(convertToOOXML({ 
                tag: "w:tc",
                children: [
                    { tag: "w:tcPr", children: props },
                    blankParagraph()
                ]
            }, parentOOXML));
            
            colId++;
        }
    }
    Array.from(node.childNodes).forEach((cn) => {
        processRowIds();
        const rowSpan = parseInt(cn.rowSpan);
        if (!isNaN(rowSpan) && rowSpan > 1) {
            ctx.vMerges[colId] = rowSpan;
        }
        colId++;
        parseHTMLToOoxmlCursively(ctx, cn, parentOOXML).forEach(pr => ooxmlChildren.push(pr));
    });
    processRowIds();
    return [convertToOOXML({
        tag: "w:tr",
        ooxmlChildren,
        children: [{tag: "w:trPr", children: [
            {
                tag: "w:tblCellSpacing",
                attrs: { "w:w": "0", "w:type": "nil" }
            }
        ]}]
    }, parentOOXML)];
}